import type { ProspectSort } from "../../api/client.ts";
import type { ProspectBaseColumn } from "../../components/prospects/ProspectTable.tsx";

/** The columns the collection's column picker hides ("saved for everyone"). */
export type BaseColumnKey =
  | "found_by"
  | "hits"
  | "status"
  | "contacts"
  | "labels"
  | "added_by"
  | "date_added"
  | "time";

export const BASE_COLUMNS: { key: BaseColumnKey; label: string }[] = [
  { key: "found_by", label: "Found by" },
  { key: "hits", label: "Hits" },
  { key: "status", label: "Status" },
  { key: "contacts", label: "Contacts" },
  { key: "labels", label: "Labels" },
  { key: "added_by", label: "Added by" },
  { key: "date_added", label: "Date added" },
  { key: "time", label: "Last hit" },
];

/** The picker's keys the shared prospect table draws itself. */
export const TABLE_COLUMNS: readonly ProspectBaseColumn[] = ["found_by", "hits", "status", "time"];

export const DEFAULT_SORT: ProspectSort = "added";

/**
 * A saved sort as the API takes it. Older settings name the browser's sort
 * keys: the date added, contacts, company, or a bare label key.
 */
export function serverSort(key: string | null): ProspectSort {
  if (!key) return DEFAULT_SORT;
  if (key === "date_added") return "added";
  if (["added", "contacts", "company", "hits", "last_hit", "first_hit"].includes(key)) {
    return key as ProspectSort;
  }
  if (key.startsWith("label:")) return key as ProspectSort;
  // Country and domain sorted in the browser only.
  if (key === "country" || key === "domain") return DEFAULT_SORT;
  return `label:${key}`;
}
